import { css } from "@emotion/core";
import Image from 'gatsby-image';
import React from "react";
import { Cell, Row } from '../grid/grid.component';
import { settings } from '../grid/settings';

class MediaFullWidth extends React.Component {

  render() {
    const { images } = this.props;
    if (this.props.images.length > 1) {
      return (
        <div>
          <Row css={sbs_row}>
            <Cell.x5 css={sbs_cell}>
              <Image fluid={images[0].image.localFile.childImageSharp.fluid} />

            </Cell.x5>
            <Cell.x2>
              <div className='caption caption-left'>{images[0].caption.text}</div>
              <div className='caption caption-right'>{images[1].caption.text}</div>
            </Cell.x2>
            <Cell.x5 css={sbs_cell}>
              <Image fluid={images[1].image.localFile.childImageSharp.fluid} />

            </Cell.x5>

          </Row>
        </div>
      )
    }
    return (
      <div>
        <Row>
          {this.props.images.map((image, i) => (
            <Cell key={i}>
              <div className="block-img">
                <Image fluid={image.image.localFile.childImageSharp.fluid} />
              </div>
              <div className="caption">{image.caption.text}</div>
            </Cell>
          ))}
        </Row>
      </div>
    )
  }
}

export default MediaFullWidth




const sbs_row = css`
  
  justify-content: space-between;

`;

const sbs_cell = css`
  

  @media (max-width: ${settings.mobileWidth - 1}px){
    display: block;
    flex: none;
    width: 100%;
    max-width: 100%;
    &:first-of-type{
      margin-bottom: 100px;
    }
  }

`;